module.exports = __webpack_public_path__ + "img/vector-dashboard.4723e322.svg";